import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const PALETTES = {
  sky:    { name: 'Sky',    swatch: '#7EC8E3', description: 'Baby blue (default)' },
  slate:  { name: 'Slate',  swatch: '#94A3B8', description: 'Cool neutral gray'   },
  rose:   { name: 'Rose',   swatch: '#FB7185', description: 'Warm blush pink'     },
  forest: { name: 'Forest', swatch: '#4ADE80', description: 'Fresh emerald green' },
  sand:   { name: 'Sand',   swatch: '#D4A574', description: 'Warm desert amber'   },
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem('fly_theme');
    if (stored) return stored;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  const [palette, setPaletteState] = useState(() => {
    const stored = localStorage.getItem('fly_palette');
    return stored && PALETTES[stored] ? stored : 'sky';
  });

  // Apply dark / light class
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('fly_theme', theme);
  }, [theme]);

  // Apply palette via data-palette attribute on <html>
  useEffect(() => {
    document.documentElement.dataset.palette = palette;
    localStorage.setItem('fly_palette', palette);
  }, [palette]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');
  const setPalette = (key) => { if (PALETTES[key]) setPaletteState(key); };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, palette, setPalette }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};

export default ThemeContext;
